var map = {
	"./Approved.svg": 3853,
	"./AwaitingParts.svg": 3854,
	"./Closed.svg": 3855,
	"./Completed.svg": 3856,
	"./Excel.svg": 3857,
	"./Exportall_grey.svg": 3858,
	"./Exportall_grey_circle.svg": 3859,
	"./InProgress.svg": 3860,
	"./New.svg": 3861,
	"./View_Pic_Grey.svg": 3862,
	"./accident.svg": 3863,
	"./account.svg": 3864,
	"./addOrange.svg": 3865,
	"./addUser.svg": 3866,
	"./addVehicle.svg": 3867,
	"./address.svg": 3868,
	"./alert.svg": 3869,
	"./all_active.svg": 3870,
	"./all_active_es.svg": 3871,
	"./arrow-down.svg": 3872,
	"./arrow-up.svg": 3873,
	"./arrowRight.svg": 3874,
	"./awaiting_parts_grey.svg": 3875,
	"./awaiting_parts_orange.svg": 3876,
	"./back-btn.svg": 3877,
	"./back-button-grey.svg": 3878,
	"./backButton.svg": 3879,
	"./bills_of_landing_active.svg": 3880,
	"./bills_of_landing_active_es.svg": 3881,
	"./bobTail.svg": 3882,
	"./book-solid.svg": 3883,
	"./boxTruck.svg": 3884,
	"./calanderIcon.svg": 3885,
	"./cameraSelected.svg": 3886,
	"./camera_selected.svg": 3887,
	"./chat-icon.svg": 3888,
	"./circle-Exportall_grey.svg": 3889,
	"./circle-export.svg": 3890,
	"./circle-exportUser.svg": 3891,
	"./circle-import.svg": 3892,
	"./circle-importUser.svg": 3893,
	"./circle-viewall.svg": 3894,
	"./clearAll.svg": 3895,
	"./close-popup.svg": 3896,
	"./closeMap.svg": 3897,
	"./closed-Orange.svg": 3898,
	"./closed-grey.svg": 3899,
	"./clusterIcon.svg": 3900,
	"./communication_records_active.svg": 3901,
	"./communication_records_active_es.svg": 3902,
	"./company.svg": 3903,
	"./companyIcon.svg": 3904,
	"./complete-Orange.svg": 3905,
	"./complete-grey.svg": 3906,
	"./csa.svg": 3907,
	"./csaSnapshot.svg": 3908,
	"./dailyDocuments.svg": 3909,
	"./dashboard.svg": 3910,
	"./dashboardIcon.svg": 3911,
	"./date.svg": 3912,
	"./delete.svg": 3913,
	"./deleteCircle.svg": 3914,
	"./delivery_receipts_active.svg": 3915,
	"./delivery_receipts_active_es.svg": 3916,
	"./departments.svg": 3917,
	"./departmetEdit.svg": 3918,
	"./developer.svg": 3919,
	"./direction.svg": 3920,
	"./dispatch_records_active.svg": 3921,
	"./dispatch_records_active_es.svg": 3922,
	"./document.svg": 3923,
	"./documents.svg": 3924,
	"./dot.svg": 3925,
	"./dotAudit.svg": 3926,
	"./dotauditIcon.svg": 3927,
	"./downarrowIcon.svg": 3928,
	"./download.svg": 3929,
	"./downloadCenter.svg": 3930,
	"./downloadCenterMenu.svg": 3931,
	"./driver-behaviour.svg": 3932,
	"./driver.svg": 3933,
	"./dryVan.svg": 3934,
	"./dtc.svg": 3935,
	"./dualCam.svg": 3936,
	"./dump.svg": 3937,
	"./edit.svg": 3938,
	"./editLogIcon.svg": 3939,
	"./editSvg.svg": 3940,
	"./en.svg": 3941,
	"./es.svg": 3942,
	"./excelNew.svg": 3943,
	"./export-grey.svg": 3944,
	"./export.svg": 3945,
	"./exportUser.svg": 3946,
	"./feedback.svg": 3947,
	"./file-pdf-regular.svg": 3948,
	"./filter.svg": 3949,
	"./flatBed.svg": 3950,
	"./fleet.svg": 3951,
	"./fleetCompanies.svg": 3952,
	"./fleetdriverIcon.svg": 3953,
	"./fleetvehiclesIcon.svg": 3954,
	"./fletBed.svg": 3955,
	"./fr.svg": 3956,
	"./fuel.svg": 3957,
	"./full.svg": 3958,
	"./hamburger.svg": 3959,
	"./help-icon.svg": 3960,
	"./historyLogs.svg": 3961,
	"./icon-delete.svg": 3962,
	"./icon-export.svg": 3963,
	"./icon-menu-logs.svg": 3964,
	"./ifta.svg": 3965,
	"./import.svg": 3966,
	"./importUser.svg": 3967,
	"./in_progress_grey.svg": 3968,
	"./in_progress_orange.svg": 3969,
	"./infoTruck.svg": 3970,
	"./inspection-dvir.svg": 3971,
	"./inspection.svg": 3972,
	"./key.svg": 3973,
	"./leftArrow.svg": 3974,
	"./location.svg": 3975,
	"./locationMap.svg": 3976,
	"./log.svg": 3977,
	"./logEdit.svg": 3978,
	"./logHistory.svg": 3979,
	"./logoutIcon.svg": 3980,
	"./logs.svg": 3981,
	"./logsIcon.svg": 3982,
	"./mack.svg": 3983,
	"./mail.svg": 3984,
	"./main_camera.svg": 3985,
	"./mappinPopup.svg": 3986,
	"./menu_companies.svg": 3987,
	"./menu_dailyLog.svg": 3988,
	"./menu_reports.svg": 3989,
	"./menu_reseller.svg": 3990,
	"./menu_vehicle.svg": 3991,
	"./messageSender.svg": 3992,
	"./messaging.svg": 3993,
	"./new_login.svg": 3994,
	"./ninePin.svg": 3995,
	"./nonEdit.svg": 3996,
	"./notFull.svg": 3997,
	"./not_started_grey.svg": 3998,
	"./not_started_orange.svg": 3999,
	"./otherTrailer.svg": 4000,
	"./otherTruck.svg": 4001,
	"./other_documents_active.svg": 4002,
	"./other_documents_active_es.svg": 4003,
	"./overview.svg": 4004,
	"./page-first.svg": 4005,
	"./page-last.svg": 4006,
	"./page-next.svg": 4007,
	"./page-prev.svg": 4008,
	"./phone.svg": 4009,
	"./pickup.svg": 4010,
	"./pneumaticTrailer.svg": 4011,
	"./policy.svg": 4012,
	"./popupClose.svg": 4013,
	"./popupConfirm.svg": 4014,
	"./popupDelete.svg": 4015,
	"./privatePassenger.svg": 4016,
	"./qbdii.svg": 4017,
	"./receipts_active.svg": 4018,
	"./receipts_active_es.svg": 4019,
	"./reeferTrailer.svg": 4020,
	"./refreshCircle.svg": 4021,
	"./renewal.svg": 4022,
	"./repair.svg": 4023,
	"./reportIcon.svg": 4024,
	"./reports.svg": 4025,
	"./save-regular.svg": 4026,
	"./scoreCard.svg": 4027,
	"./searchGrey.svg": 4028,
	"./selectedConnection.svg": 4029,
	"./share.svg": 4030,
	"./sixPin.svg": 4031,
	"./sort.svg": 4032,
	"./speedometer.svg": 4033,
	"./spotlightGreen.svg": 4034,
	"./spotlightGrey.svg": 4035,
	"./spotlightRed.svg": 4036,
	"./straightTruck.svg": 4037,
	"./supportIcon.svg": 4038,
	"./switch.svg": 4039,
	"./tankerTrailer.svg": 4040,
	"./tick.svg": 4041,
	"./time.svg": 4042,
	"./timePicker.svg": 4043,
	"./toggle-off.svg": 4044,
	"./toggle-on.svg": 4045,
	"./tools.svg": 4046,
	"./tractorDayCab.svg": 4047,
	"./tractorSleeper.svg": 4048,
	"./undelete.svg": 4049,
	"./unsaved.svg": 4050,
	"./update.svg": 4051,
	"./upload.svg": 4052,
	"./usdot.svg": 4053,
	"./user.svg": 4054,
	"./userprofileIcon.svg": 4055,
	"./users.svg": 4056,
	"./vacuumTrailer.svg": 4057,
	"./vacuumTruck.svg": 4058,
	"./van.svg": 4059,
	"./vehicle-behaviour.svg": 4060,
	"./vehicle.svg": 4061,
	"./vehicleIcon.svg": 4062,
	"./viewArrow.svg": 4063,
	"./viewDocument.svg": 4064,
	"./viewReports.svg": 4065,
	"./viewStatus.svg": 4066,
	"./viewallMap.svg": 4067,
	"./violation.svg": 4068,
	"./volvo.svg": 4069,
	"./weigh_tickets_active.svg": 4070,
	"./weigh_tickets_active_es.svg": 4071,
	"./whitecheck_new.svg": 4072
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3852;